var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"chart"}},[_c('v-row',[_c('v-col',{attrs:{"lg":"12"}},[_c('strong',[_vm._v("Sentiment")]),_c('apexchart',{ref:"realtimeChart",attrs:{"type":"pie","height":"350","options":_vm.chartOptions,"series":_vm.series}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }